var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('LoyaltySummaryChartContainer',{attrs:{"loyaltySummaryChart":_vm.metrics.loyaltySummaryChart}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Checkins")])])])])
}]

export { render, staticRenderFns }